import { Tween, Easing } from '@tweenjs/tween.js';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';

class BalanceController {
	currentData = null;
	constructor(vc, conf) {
		this.vc = vc;
		this.configs = conf;
		this.balance = GameConfigs.auth.balance.amount;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.init();
		this.addEventListeners();
		this.setBalance();
	}

	init() {
		this.BALANCE_LABEL = this.vc[this.configs.holder].Balance.BALANCE_LABEL;
		this.BALANCE_VALUE = this.vc[this.configs.holder].Balance.BALANCE_VALUE;
		this.BALANCE_LABEL.anchor.x = 0;
		this.BALANCE_VALUE.anchor.x = 0;
	}

	addEventListeners() {
		window.addEventListener(
			EVENTS.SERVER_MSG,
			this.serverMessage.bind(this),
			false
		);
		window.addEventListener(
			EVENTS.MAIN_LINE_FINISHED,
			this.mainLineFinished.bind(this),
			false
		);
	}

	resize(w, h) {
		if (!isDesktop) {
			if (w >= h) {
				this.BALANCE_LABEL.style.fontSize = 26;
				this.BALANCE_VALUE.style.fontSize = 30;
				this.BALANCE_LABEL.y = -50;
				this.BALANCE_VALUE.y = -24;
			} else {
				this.BALANCE_LABEL.style.fontSize = 16;
				this.BALANCE_VALUE.style.fontSize = 18;
				this.BALANCE_LABEL.y = 12;
				this.BALANCE_VALUE.y = 29;
				this.BALANCE_LABEL.x = 12;
				this.BALANCE_VALUE.x = 12;
			}
		} else {
			this.BALANCE_LABEL.style.fontSize = 16;
			this.BALANCE_VALUE.style.fontSize = 18;
			this.BALANCE_LABEL.y = -10;
			this.BALANCE_VALUE.y = 7;
			this.BALANCE_LABEL.x = 6;
			this.BALANCE_VALUE.x = 6;
		}
	}

	serverMessage(e) {
		switch (e.detail.service) {
			case 'bet':
				this.currentData = e.detail.data;
				GameConfigs.auth.balance.amount = e.detail.data.balance;
				this.updateBalance(e.detail.data.balancebefore);
				break;
			case 'bonusstep':
			case 'freespinstep':
				this.currentData = e.detail.data;
				GameConfigs.auth.balance.amount = e.detail.data.balance;
				break;
			default:
				break;
		}
	}

	mainLineFinished() {
		if (this.currentData) {
			this.updateBalance(this.currentData.balance);
			this.currentData = null;
		}
	}

	setBalance() {
		this.BALANCE_VALUE.text = formatCurrencyValue(this.balance, this.currency);
	}

	updateBalance(balance) {
		this.tweener = new Tween(this)
			.to({ balance: balance }, 500)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setBalance();
			})
			.start();
	}
}

export default BalanceController;
